import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
// @ts-expect-error - imagetools directives
import dashboardSrcSet from "../../assets/images/dashboard.png?w=400;800;1186&format=webp&as=srcset";
// @ts-expect-error - imagetools directives
import dashboardFallback from "../../assets/images/dashboard.png?w=1186&format=png";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ROUTES } from "@/lib/constants/routes";

const HeroSection = () => {
    const { t } = useTranslation();

    return (
        <section className="relative min-h-screen flex items-center mt-10 pt-20 lg:pt-0 overflow-hidden animate-fade-up">
            {/* Background Pattern */}
            <div className="absolute inset-0 geometric-pattern opacity-50" />

            {/* Gradient Overlay */}
            <div
                className="absolute inset-0 opacity-60"
                style={{ background: "var(--gradient-hero)" }}
            />

            {/* Floating Shapes */}
            <div className="absolute top-1/4 right-1/4 w-64 h-64 bg-african-accent/10 rounded-full blur-3xl animate-float" />
            <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-african-secondary/10 rounded-full blur-3xl animate-float" style={{ animationDelay: '-3s' }} />

            <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
                    {/* Content */}
                    <div className="text-center lg:text-left">
                        {/* Badge */}
                        <div className="inline-flex items-center gap-2 px-4 py-2 bg-african-accent/10 rounded-full mb-6 animate-fade-up">
                            <span className="w-2 h-2 bg-african-accent rounded-full animate-pulse" />
                            <span className="text-sm font-medium text-african-accent">{t('landing.hero.badge')}</span>
                        </div>

                        {/* Headline */}
                        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold leading-tight mb-6 animate-fade-up-delay-1">
                            <span className="text-foreground">{t('landing.hero.titlePart1')} </span>
                            <span className="text-gradient block">{t('landing.hero.titlePart2')}</span>
                        </h1>

                        {/* Subheadline */}
                        <p className="text-lg sm:text-xl text-muted-foreground max-w-xl mx-auto lg:mx-0 mb-8 animate-fade-up-delay-2">
                            {t('landing.hero.subtitle')}
                        </p>

                        {/* CTA Buttons */}
                        <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start animate-fade-up-delay-3">
                            <Button asChild className="bg-african-accent hover:bg-african-accent/90 text-white shadow-African h-14 px-8 rounded-xl font-bold text-lg">
                                <Link to={`${ROUTES.REGISTER}`}>
                                    {t('landing.hero.cta')}
                                    <ArrowRight className="ml-2" />
                                </Link>
                            </Button>
                        </div>

                        {/* Social Proof */}
                        <div className="mt-12 flex flex-col sm:flex-row items-center gap-6 justify-center lg:justify-start animate-fade-up-delay-3">
                            <div className="flex -space-x-3">
                                {[1, 2, 3, 4, 5].map((i) => (
                                    <div
                                        key={i}
                                        className="w-10 h-10 rounded-full bg-muted border-2 border-background flex items-center justify-center overflow-hidden"
                                    >
                                        <div className="w-full h-full bg-african-accent/20 flex items-center justify-center text-african-accent text-xs font-bold">
                                            {String.fromCharCode(64 + i)}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="text-sm">
                                <span className="font-bold text-foreground">2,500+</span>
                                <span className="text-muted-foreground"> {t('landing.hero.stats')}</span>
                            </div>
                        </div>
                    </div>

                    {/* Hero Visual */}
                    <div className="relative animate-scale-in">
                        <div className="relative">
                            {/* Main Card */}
                            <div className="bg-card rounded-3xl shadow-strong p-6 lg:p-8 border border-border">
                                <div className="aspect-video bg-muted rounded-2xl mb-6 flex items-center justify-center overflow-hidden relative">
                                    <img
                                        src={dashboardFallback}
                                        srcSet={dashboardSrcSet}
                                        sizes="(max-width: 640px) 400px, (max-width: 1024px) 800px, 1186px"
                                        alt="dashboard"
                                        width="1186"
                                        height="668"
                                        className="w-full h-full object-cover opacity-90"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                                </div>
                                {/* <p className="text-muted-foreground font-medium text-center">{t('landing.hero.mockupTitle')}</p> */}
                            </div>

                            {/* Decorative elements using African accent */}
                            <div className="absolute -top-4 -right-4 w-24 h-24 bg-african-accent/10 rounded-full -z-10 blur-xl animate-pulse" />
                            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-african-secondary/10 rounded-full -z-10 blur-xl animate-pulse" style={{ animationDelay: '-1s' }} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
